import { HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';

const uuid = `${Date.now()}-${Math.random().toString(36).slice(2)}`;

export const HeadersInterceptor: HttpInterceptorFn = (
    request: HttpRequest<unknown>,
    next: HttpHandlerFn,
) => {
    request = request.clone({
        headers: request.headers.set('x-session-id', uuid),
    });

    return next(request);
};
